export default {
  title: 'Contact form',
  fillIn: 'Fill out all required fields',
  heading: 'Contact details',
  name: 'Name *',
  surname: 'Surname *',
  email: 'E-mail *',
  phone: 'Numer telefonu',
  heading2: 'Adres kontaktowy',
  street: 'Ulica *',
  number: 'Numer budynku *',
  city: 'Miasto',
  postalCode: 'Kod pocztowy *',
  info: 'After receiving your contact form, we will contact you within 3 working days with an attractive offer tailored to your volume. Once you accept it, we can start working on project details including timeline to meet your expectations.',
  permit:
    `The administrator of the personal data included in the contact form ("Form") is Nutricia Polska Sp. z o.o. with its registered office in Warsaw (Bobrowiecka 8 Street, 00-728).
    The data indicated on the Form will be processed in order to respond to your request for pricing, by telephone and/or e-mail, in accordance with Article 6(1)(f) of the GDPR. The submission of data is voluntary, but necessary to use the service of the Form.
    Sending an Enquiry through the Form shall be considered as an expression of consent to the processing of personal data provided in the Form, by Nutricia Polska S.A. and receiving a response to the enquiry by e-mail and/or telephone.
    You have the right to request access to data, its correction, deletion, restriction, transfer, revocation of consent, lodging an objection and complaint. For full information please see the <b><a href="https://www.nutricia.com.pl/polityka-prywatnosci">'Privacy Policy'</a></b>.`,
  submit: 'Send an inquiry',
  error: 'Field is required',
  permitError: 'Zgoda jest wymagana',
};
